export interface EmailTemplateListItem {
  templateKey: string;
  name: string;
  category: string;
  subject: string;
  previewText: string;
  availableVariables: string[];
  updatedAt: string | null;
  isActive: boolean;
}

export interface EmailTemplate extends EmailTemplateListItem {
  htmlContent: string;
}

export interface TemplateVersion {
  subject: string;
  previewText: string;
  htmlContent: string;
  savedAt: string;
  /** Present only if the API records it; the row degrades without it. */
  savedBy?: string;
}

export const CATEGORY_ORDER = ['DRIP_JOBSEEKER', 'DRIP_EMPLOYER', 'TRANSACTIONAL', 'CONTENT', 'AUTH'];

export const CATEGORY_LABELS: Record<string, string> = {
  DRIP_JOBSEEKER: 'Jobseeker Drip (8 steps)',
  DRIP_EMPLOYER: 'Employer Drip (8 steps)',
  TRANSACTIONAL: 'Transactional',
  // Announcements of new blog posts and guides, each paused through its ct-* rule.
  CONTENT: 'Content',
  AUTH: 'Auth',
};

/**
 * Audience is derived from category rather than stored separately, so the two
 * cannot disagree. TRANSACTIONAL and AUTH go to whoever triggered them, so they
 * are not audience-specific and carry no key-prefix rule.
 */
export const AUDIENCE_BY_CATEGORY: Record<string, 'Jobseekers' | 'Employers'> = {
  DRIP_JOBSEEKER: 'Jobseekers',
  DRIP_EMPLOYER: 'Employers',
};

/**
 * The key a drip template of each audience starts with. Only the drip categories map to an
 * audience (AUDIENCE_BY_CATEGORY), so this is a drip rule. It said js- / em-, which no drip key has
 * ever started with (JOBSEEKER_DRIP_n, now jobseeker-drip-n), so the editor showed a blocker on
 * every drip email and refused to save it.
 */
export const KEY_PREFIX_BY_AUDIENCE: Record<'Jobseekers' | 'Employers', string> = {
  Jobseekers: 'jobseeker-drip-',
  Employers: 'employer-drip-',
};

/**
 * Every email template key: lowercase words joined by hyphens (owner, 2026-10-28). The backend
 * enforces it (EmailTemplateKeys.FORMAT); this is the same rule, so a form can say so before saving.
 */
export const TEMPLATE_KEY_FORMAT = /^[a-z0-9]+(-[a-z0-9]+)*$/;

/** Where most inboxes cut the subject line. */
export const SUBJECT_TRUNCATION = 60;
